<template>
	<!-- 配置分页的组件 -->
	<div class="pageComlist">
		<div class="pageCom col-xs-12 col-sm-10 col-md-10 col-lg-5">
			<div>
				<el-pagination background layout="slot,prev, pager, next" :page-size="pageSize" :total="total"
					:pager-count="5" :current-page="pageNum" @current-change="search">
					<el-button class="pageBtn" :disabled="pageNum === 1" @click="search(1)">首页</el-button>
				</el-pagination>
			</div>
			<div>
				<el-pagination layout="slot">
					<el-button class="pageBtn" :disabled="pageNum === Math.ceil(total / pageSize)"
						@click="search(Math.ceil(total / pageSize))">末页</el-button>
				</el-pagination>
			</div>
		</div>
	</div>

</template>
<script>
	/**
	 * 分页共通组件
	 */
	export default {
		name: "ThePagination",
		props: {
			/**
			 * 定义 ThePagination组件特有的属性
			 */
			attribute: {
				handleChange() {}
			},
			pageNumber: {
				type: Number,
			},
			visibilityHeight: {
				type: Number,
				default: 400
			},
			backPosition: {
				type: Number,
				default: 0
			}
		},
		data() {
			return {
				pageSize: 10,
				total: this.total,
				pageNum: 1
			};
		},
		methods: {
			search(num) {
				this.pageNum = num
			}
		}
	};
</script>

<style scoped lang="less">
	.pageComlist {
		width: 100%;
		.pageCom {
			// width: 30vw;
			margin: 10px auto;
			display: flex;
			justify-content: center;
			-webkit-justify-content: center;
			background: #fff;
			padding: 10px 1rem;
			border-radius: 30px;
			box-sizing: border-box;
			box-shadow: 5px 5px 5px 0;
		}
		
	}


	
	.el-pagination {
		padding: 0;
	}

	.el-pagination.is-background .el-pager li:not(.disabled).active {
		height: 30px;
		line-height: 30px;
		border: #BC1920;
		background-color: #BC1920;
		color: #FFF;
	}

	.el-pagination.is-background .btn-prev,
	.el-pagination.is-background .btn-next {
		margin: 0 10px;
		height: 30px;
		background: #fff;
		border: 1px solid #F0F2F5;
	}

	.el-pagination.is-background .el-pager li {
		height: 30px;
		line-height: 30px;
		border: 1px solid #F0F2F5;
		margin: 0;
		font-weight: 400;
		font-size:0.6rem;
	}

	
	

	.el-pagination .pageBtn {
		width: 48px;
		height: 30px;
		border: 1px solid #F0F2F5;
		border-radius: 0;
		background: #fff;
		color: #606266;
	}

	.el-pagination button:not(.is-disabled):hover,
	.el-pagination.is-background .el-pager li:not(.active):not(.disabled):hover {
		color: #BC1920;
	}

	.el-pagination button,
	.el-pagination span:not([class*=suffix]) {
		height: 30px;
		line-height: 30px
	}
</style>
